import { useNavigate } from "react-router-dom"

import { AccountSettingsAdditionalInfo } from "modals/AccountSettingsAdditionalInfo"

import { AccountRoutePanel } from "./shared"

export const ContractorAdditionalInformationPage = () => {
  const navigate = useNavigate()

  return (
    <AccountRoutePanel>
      <AccountSettingsAdditionalInfo onCancel={() => navigate(-1)} />
    </AccountRoutePanel>
  )
}
